module.exports = __webpack_public_path__ + "img/icon_secChoice_02.5d723ea7.png";